import { Typography, Stack, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setOrderChangeHistoryDialog } from "../../../../app/slices/jomla/orderSlice";
import { DataGrid } from "@mui/x-data-grid";
import ResponsiveDataGrid from "../../../../components/MobileList/ResponsiveDataGrid";
import dayjs from "dayjs";
import { HiOutlineClock } from "react-icons/hi2";
import FormDialog, { PlainCard } from "../../../../components/FormDialog";

const OrderChangeHistoryDialog = () => {
  const dispatch = useDispatch();

  const _JOrder = useSelector((state) => state.jOrder.orderChangeHistory);

  const handleDialog = () => {
    dispatch(setOrderChangeHistoryDialog({}));
  };

  const columns = [
    {
      field: "created_by_name",
      headerName: "المستخدم",
      flex: 1,
    },
    {
      field: "old",
      headerName: "القيمة القديمة",
      flex: 1,
      renderCell: (params) => parseInt(params.row.old)?.toLocaleString(),
    },
    {
      field: "new",
      headerName: "القيمة الجديدة",
      flex: 1,
      renderCell: (params) => parseInt(params.row.new)?.toLocaleString(),
    },
    {
      field: "type",
      headerName: "النوع",
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "تاريخ الانشاء",
      flex: 1,
      renderCell: (params) => (
        <Stack spacing={0}>
          <Typography variant="body1">
            {dayjs(params.row.created_at).format("YYYY-MM-DD")}
          </Typography>
          <Typography variant="body1">
            {dayjs(params.row.created_at).format("hh:mm a")}
          </Typography>
        </Stack>
      ),
    },
  ];

  return (
    <FormDialog
      open={_JOrder.dialog}
      maxWidth="md"
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineClock />}
      title="سجل التعديلات"
    >
      <PlainCard>
        <Box sx={{ height: { xs: "auto", md: "66vh" }, width: "100%" }}>
          <ResponsiveDataGrid gridHeight={null}
            rows={_JOrder.data}
            columns={columns}
            rowCount={_JOrder.total}
            loading={_JOrder.loading}
            rowHeight={60}
            pagination
            paginationMode="client"
            selectionModel={[]}
          />
        </Box>
      </PlainCard>
    </FormDialog>
  );
};

export default OrderChangeHistoryDialog;
